import script from "./StatusButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./StatusButtons.vue?vue&type=script&setup=true&lang=js"

import "./StatusButtons.vue?vue&type=style&index=0&id=e6c1fcc2&scoped=true&lang=css"

import exportComponent from "/home/interact/webapp/4.frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6c1fcc2"]])

export default __exports__